module.exports = __webpack_public_path__ + "img/ltkshoecrush-1x.fbfbcca.jpg";